import { Common } from "@taabl/common-lib/constants/common";
import React from "react";
import { Col, Row } from "react-bootstrap";
import useAuth from "../../contexts/useAuth";
import BankAccountSetup, { showBankAcccount } from "./BankAccountSetup";
import useEmployeeContext from "./contexts/useEmployeeContext";
import PayStub, { showPayStub } from "./PayStub";
import SetupCompleteMessage from "./SetupCompleteMessage";

export const isUnAvailableRegion = (employee) => {
  return employee && !Common.ALLOWED_STATES_FOR_SIGNUP.includes(employee.state);
};

function usePrevious(value) {
  const ref = React.useRef();
  React.useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}
const SetupComplete = () => {
  const { employee } = useEmployeeContext();
  const prevEmployee = usePrevious(employee);
  const [showSetUpComplete, setShowSetUpComplete] = React.useState(false);
  const { user: loggedInUser, refreshUser } = useAuth();
  React.useEffect(() => {
    // We want to set set up complete if employee has changed from not having paystub to having paystub
    // or completing bank step
    console.log("prevEmployee", prevEmployee);
    console.log("employee", employee);
    if (
      prevEmployee &&
      employee &&
      ((showPayStub(prevEmployee) &&
        !showPayStub(employee) &&
        !showBankAcccount(employee)) ||
        (showBankAcccount(prevEmployee) &&
          !showBankAcccount(employee) &&
          !showPayStub(employee)))
    ) {
      setShowSetUpComplete(true);
      // check if logged in user is same as employee
      if (employee && loggedInUser && loggedInUser.id === employee.id) {
        refreshUser();
      }
    }
  }, [employee]);

  if (showSetUpComplete) {
    return <SetupCompleteMessage />;
  }
  if (
    !showPayStub(employee) &&
    !showBankAcccount(employee) &&
    !isUnAvailableRegion(employee)
  ) {
    return <></>;
  }
  return (
    <Row className="mb-3">
      <Col sm={12}>
        <div className="bordered-box font-secondary d-flex flex-column">
          {employee &&
            (showPayStub(employee) || showBankAcccount(employee)) &&
            !isUnAvailableRegion(employee) && (
              <div className="text-gray fw-bold px-4 py-2">Almost Done</div>
            )}
          {isUnAvailableRegion(employee) && (
            <div className="bg-pink px-4 py-3 font-secondary mt-1 mb-1 font-bold text-danger">
              We are working to be able to legally lend in your area. We will
              send you an e-mail when we are able to lend in your area.
            </div>
          )}
          <PayStub />
          <BankAccountSetup />
        </div>
      </Col>
    </Row>
  );
};

export default SetupComplete;
